'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Input = function Input(_ref) {
  var theme = _ref.theme,
      title = _ref.title,
      placeHolder = _ref.placeHolder,
      id = _ref.id,
      blurCallback = _ref.blurCallback,
      callback = _ref.callback,
      error = _ref.error,
      required = _ref.required,
      optional = _ref.optional,
      pattern = _ref.pattern,
      type = _ref.type,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      populatedValue = _ref.populatedValue,
      autofill = _ref.autofill;
  return _react2["default"].createElement('label', {
    className: 'nwc--input ' + theme,
    htmlFor: id
  }, _react2["default"].createElement('div', {
    className: 'nwc--label-wrap'
  }, _react2["default"].createElement('strong', {
    className: 'font--14'
  }, title, required === true && _react2["default"].createElement('sup', {
    className: 'font--error font--10'
  }, ' *'), optional === true && _react2["default"].createElement('sup', {
    className: 'font--grey font--10'
  }, ' (optional)'))), _react2["default"].createElement('input', {
    maxLength: maxLength,
    minLength: minLength,
    defaultValue: populatedValue,
    type: type,
    className: 'border paddingMD font16',
    placeholder: placeHolder,
    id: id,
    name: id,
    onChange: function onChange(e) {
      return callback(e.target.value);
    },
    autofill: autofill,
    onBlur: function onBlur(e) {
      return blurCallback(e.target.value);
    },
    pattern: pattern
  }), error !== null && _react2["default"].createElement('aside', {
    className: 'nwc--validation nwc--validation--error font--12'
  }, error));
};

Input.defaultProps = {
  theme: '',
  populatedValue: null,
  error: null,
  type: 'text',
  required: false,
  optional: false,
  pattern: null,
  maxLength: 50,
  minLength: 1,
  autofill: 'yes',
  placeholder: null,
  blurCallback: function blurCallback() {
    return true;
  }
};
Input.propTypes = {
  theme: _propTypes.PropTypes.string,
  blurCallback: _propTypes.PropTypes.func,
  populatedValue: _propTypes.PropTypes.string,
  minLength: _propTypes.PropTypes.number,
  maxLength: _propTypes.PropTypes.number,
  type: _propTypes.PropTypes.string,
  title: _propTypes.PropTypes.string.isRequired,
  placeHolder: _propTypes.PropTypes.string,
  id: _propTypes.PropTypes.string.isRequired,
  callback: _propTypes.PropTypes.func.isRequired,
  error: _propTypes.PropTypes.string,
  required: _propTypes.PropTypes.bool,
  optional: _propTypes.PropTypes.bool,
  pattern: _propTypes.PropTypes.string,
  autofill: _propTypes.PropTypes.string
};
exports["default"] = Input;